import aT from '../const/action-type'
import initial from '../store/initial'

export default (state = initial.dummyShiftCandidates, action) => {
  switch (action.type) {
    case aT.SET_DUMMY_SHIFT_CANDIDATES:
      return [...action.data]
    case aT.RESET_STORE:
      return initial.dummyShiftCandidates
    case aT.SWITCH_WORKSPACE:
      return initial.dummyShiftCandidates
    default:
      return state
  }
}
